import QRCode from 'qrcode.react';
import React from 'react';

interface QRWriterProps {
    size?: number;
    value: string;
}

export const QRWriter: React.FC<QRWriterProps> = ({ size = 150, value }) => (
    <QRCode id="temporaryBadge" value={value} size={size} style={{ maxWidth: '100%' }} renderAs="svg" />
);
